import SDIcon from '../../SDIcon'

const IconFlagBE = (props) => (
  <SDIcon title='Belgium' defaultColorKey='contentPrimary' viewBox='0 0 24 24' {...props}>
    <rect x="3" y="6" width="18" height="12" rx="2" fill="#FFD21E" />
    <rect x="3" y="6" width="6" height="12" rx="2" fill="#111111" />
    <rect x="15" y="6" width="6" height="12" rx="2" fill="#E22D2D" />
    <rect x="3" y="6" width="18" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.35" />
  </SDIcon>
)

export default IconFlagBE
